import React from 'react';
import { Button, Dimmer, Grid, Loader, Input } from 'semantic-ui-react';
import autoBind from 'auto-bind';
import { SemanticToastContainer } from 'react-semantic-toasts';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  openCreateUserMappingModal,
  openCreateUserMappingUploadModal,
  setUserMappingSearchKeyword,
  setUserMappingPerPage,
} from 'state/userMapping/actions';
import ListMapping from './ListMapping';
import DeleteUserMappingModal from './DeleteUserMappingModal';
import CreateUserMappingModal from './CreateUserMappingModal';
import CreateUserMappingUploadModal from './CreateUserMappingUploadModal';

class UserMappingPage extends React.Component {
  constructor() {
    super();
    autoBind(this);
  }

  onCreateUserMappingButtonClick = () => {
    const { dispatch } = this.props;
    dispatch(openCreateUserMappingModal());
  };

  onBulkUploadButtonClick = () => {
    const { dispatch } = this.props;
    dispatch(openCreateUserMappingUploadModal());
  };

  handleOnSearchFieldChange = e => {
    const { dispatch } = this.props;
    dispatch(setUserMappingSearchKeyword(e.target.value));
    dispatch(setUserMappingPerPage(20));
  };

  render() {
    const {
      gettingUserMapping,
      deletingUserMapping,
      updatingUserMapping,
      creatingUserMapping,
      creatingUserMappingUpload,
      deleteUserMappingModal,
      createUserMappingModal,
      createUserMappingUploadModal,
      userMappingSearchKeyword,
    } = this.props;
    return (
      <>
        <h1>User Mapping</h1>
        <br />
        <Dimmer
          active={
            gettingUserMapping ||
            deletingUserMapping ||
            updatingUserMapping ||
            creatingUserMapping ||
            creatingUserMappingUpload
          }
          page
        >
          <Loader size="massive">Loading...</Loader>
        </Dimmer>
        {createUserMappingModal ? <CreateUserMappingModal /> : <></>}
        {deleteUserMappingModal ? <DeleteUserMappingModal /> : <></>}
        {createUserMappingUploadModal ? (
          <CreateUserMappingUploadModal />
        ) : (
          <></>
        )}
        <SemanticToastContainer />
        <Grid>
          <Grid.Column width={12}>
            <label htmlFor="search-user">Search user</label>
            <Input
              id="search-user"
              fluid
              icon="search"
              placeholder="Search..."
              onChange={this.handleOnSearchFieldChange}
              value={userMappingSearchKeyword}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <label style={{ margin: '100%' }}>
              <span>&nbsp;</span>
            </label>
            <Button color="blue" onClick={this.onCreateUserMappingButtonClick}>
              Add Mapping
            </Button>
            <Button color="blue" onClick={this.onBulkUploadButtonClick}>
              Bulk Upload
            </Button>
          </Grid.Column>
        </Grid>

        <ListMapping />
      </>
    );
  }
}

const mapStateToProps = ({ userMapping }) => ({
  gettingUserMapping: userMapping.gettingUserMapping,
  deletingUserMapping: userMapping.deletingUserMapping,
  updatingUserMapping: userMapping.updatingUserMapping,
  creatingUserMapping: userMapping.creatingUserMapping,
  creatingUserMappingUpload: userMapping.creatingUserMappingUpload,
  deleteUserMappingModal: userMapping.deleteUserMappingModal,
  createUserMappingModal: userMapping.createUserMappingModal,
  createUserMappingUploadModal: userMapping.createUserMappingUploadModal,
  userMappingSearchKeyword: userMapping.userMappingSearchKeyword,
});

UserMappingPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  gettingUserMapping: PropTypes.bool.isRequired,
  deletingUserMapping: PropTypes.bool.isRequired,
  updatingUserMapping: PropTypes.bool.isRequired,
  creatingUserMapping: PropTypes.bool.isRequired,
  creatingUserMappingUpload: PropTypes.bool.isRequired,
  deleteUserMappingModal: PropTypes.bool.isRequired,
  createUserMappingModal: PropTypes.bool.isRequired,
  createUserMappingUploadModal: PropTypes.bool.isRequired,
  userMappingSearchKeyword: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(UserMappingPage);
